import { Button, ChipMenu, GenericSuspense, List, useListFilterState, useTranslationRoute, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { Link, Outlet } from "react-router-dom";
import { useMemo } from "react";
import { THoliday } from "@bsm/graphql";
import { SchoolHolidayListItem } from "../components/SchoolHolidayListItem";
import { HolidaysQuery } from "../../../queries/HolidaysQuery";

export const SchoolHolidayContainer = () => {

    const { filter, setFilter } = useListFilterState(SCHOOL_HOLIDAY_LIST_ID,false);
    const [TITLE, ADD] = useTranslations(i18n);
    const urlParams = useUrlParamsValueToString()
    const yearMenuItems = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear - 2; i <= currentYear + 2; i++) {
            years.push({
                value: i.toString(),
                label: i.toString()
            });
        }
        return years;
    }, []);

    const activeMenus = useMemo(() => {
        return {
            year: filter?.data?.year?.value
                ? yearMenuItems.find((item) => item.value === filter?.data?.year?.value)
                : yearMenuItems[2],
        };
    }, [filter?.data?.year?.value, yearMenuItems]);


    return (
        <div>
            <div className="flex justify-between mb-4">
                <h3 className="font-semibold">{TITLE}</h3>
                <Link to={`create?${urlParams}`}>
                    <Button 
                        className="btn-default"
                        startIcon="fa-solid fa-plus"
                        label={ADD}
                    />
                </Link>
            </div>

            <div className="flex justify-end mb-6">
                <ChipMenu
                    items={yearMenuItems}
                    value={activeMenus?.year?.value}
                    className="w-35"
                    onClick={(menu) => {
                        setFilter((v: any) => ({
                           ...v, 
                            data: {
                                ...v.data,
                                year: menu.value,
                            },
                        }));

                    }}
                />
            </div>

            <List
                id={SCHOOL_HOLIDAY_LIST_ID}
                selection={false}
                isUrlParamsState={false}
                GQLRequest={HolidaysQuery}
                defaultFilter={{
                    pageSize: 25,
                    page: 0,
                    sort: [{ value: "startDate", sort: "ASC" }],
                    data: {
                        holidayType: ["SCHOOL_HOLIDAY"],
                        year: new Date().getFullYear().toString()
                    }
                }}
                onRenderRow={(row: THoliday) => (
                    <SchoolHolidayListItem {...row} />
                )}
            />

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </div>
    );
};

export const SCHOOL_HOLIDAY_LIST_ID = "school-holiday-list";

const i18n = [
    "std_school_holiday",
    'std_add'
];
